import { render, staticRenderFns } from "./entity-grid.vue?vue&type=template&id=2a0972bd&scoped=true&"
import script from "./entity-grid.ts?vue&type=script&lang=ts&"
export * from "./entity-grid.ts?vue&type=script&lang=ts&"
import style0 from "./entity-grid.scss?vue&type=style&index=0&id=2a0972bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0972bd",
  null
  
)

export default component.exports